(() => {
  const offer = document.querySelector('[data-welcome-offer]');
  if (!offer || offer.dataset.bound === 'true') return;
  offer.dataset.bound = 'true';

  const code = String(offer.dataset.discountCode || '').trim();
  const endsAt = Date.parse(offer.dataset.offerEnds || '');
  const applyButton = offer.querySelector('[data-welcome-offer-apply]');
  const closeButtons = offer.querySelectorAll('[data-welcome-offer-close]');
  const storageKey = 'philuWelcomeOffer10TipV3';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const ninetyDays = 90 * 24 * 60 * 60 * 1000;
  let visible = false;
  let eligible = false;

  const readState = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); }
    catch (_) { return null; }
  };
  const writeState = (state) => {
    try { localStorage.setItem(storageKey, JSON.stringify({ state, at: Date.now() })); }
    catch (_) {}
  };
  const isSuppressed = () => {
    if (!code || (Number.isFinite(endsAt) && Date.now() >= endsAt)) return true;
    const state = readState();
    if (!state || !Number(state.at)) return false;
    const age = Date.now() - Number(state.at);
    return state.state === 'claimed' ? age < ninetyDays : state.state === 'dismissed' ? age < sevenDays : false;
  };
  const track = (action, reason) => {
    document.dispatchEvent(new CustomEvent('philu:welcome-offer', { detail: { action, reason } }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'welcome_offer', offer_action: action, offer_trigger: reason || '' });
  };
  const hide = (state = 'dismissed') => {
    if (!visible) return;
    visible = false;
    offer.hidden = true;
    writeState(state);
    track(state);
  };
  const show = (reason) => {
    if (visible || !eligible || isSuppressed()) return;
    visible = true;
    offer.hidden = false;
    track('shown', reason);
  };

  closeButtons.forEach((button) => button.addEventListener('click', () => hide('dismissed')));
  applyButton?.addEventListener('click', () => {
    if (!code) return;
    writeState('claimed');
    track('claimed');
    applyButton.disabled = true;
    applyButton.textContent = 'Applying offer…';
    const redirect = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`);
  });
  document.addEventListener('keydown', (event) => {
    if (visible && event.key === 'Escape') hide('dismissed');
  });

  if (isSuppressed()) return;
  window.setTimeout(() => { eligible = true; }, 5000);
  window.setTimeout(() => { eligible = true; show('engaged_time'); }, 18000);

  const onScroll = () => {
    const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (window.scrollY / scrollable < 0.35) return;
    eligible = true;
    show('scroll_depth');
    window.removeEventListener('scroll', onScroll);
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  document.addEventListener('mouseout', (event) => {
    if (event.relatedTarget || event.toElement || event.clientY > 0) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    eligible = true;
    show('exit_intent');
  });
})();